<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            icon
            color="black"
            @click="open_dialog"
            :disabled="!Terminal.RFIDLogs"
            v-bind="attrs"
            v-on="on">
          <v-icon>mdi-inbox</v-icon>
        </v-btn>
      </template>
      <span>Terminal - Logs</span>
    </v-tooltip>
    <v-dialog
        v-model="dialog"
        persistent
        width="1800">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Terminal Log - {{ Terminal.name }}
          <v-spacer></v-spacer>
          <v-btn icon
                 @click="get_rfid_logs_data">
            <v-icon>mdi-reload</v-icon>
          </v-btn>
          <v-btn icon @click="close_dialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>

          <v-data-table
              :headers="headers"
              :items="comp_rfid_logs_data"
              sort-by="created_at desc"
              class="elevation-1"
          >
            <template v-slot:item.created_at="{ item }">
        <span>{{
            new Date(item.created_at.replace(" ", "T")).toLocaleString([], {
              dateStyle: 'short',
              timeStyle: 'short'
            })
          }}</span>
            </template>

          </v-data-table>


        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              text
              @click="close_dialog"
          >Schließen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: 'terminalRFIDLogs',
  props: {
    Terminal: Object,
  },
  data: () => ({
    dialog: false,
    headers: [
      {text: 'NFC - Tag', value: 'rfid_tag', align: 'center'},
      {text: 'Beschreibung', value: 'description', align: 'center'},
      {text: 'Zeit', value: 'created_at', align: 'center'},
    ]
  }),

  computed: {
    comp_rfid_logs_data() {
      return this.$store.getters['ClubApp/client_terminal_rfid_logs'];
    }
  },

  methods: {
    async open_dialog() {
      await this.get_rfid_logs_data();
      this.dialog = true;
    },
    close_dialog() {
      this.dialog = false;
      this.$store.commit('ClubApp/CLEAR_CLIENT_TERMINAL_RFIDLOGS');
    },
    async get_rfid_logs_data() {
      const Data = {
        client_id: this.Terminal.id,
      };
      await this.$store.dispatch('ClubApp/getTerminalRFIDLogs', Data);
    }
  }


}

</script>

<style scoped>

</style>